import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

interface Props {
    isSearchText?: boolean
}

export const SearchInputContainer = styled.div<Props>`
    ${cssMediaQueryBreakpoints.medium} {
        padding: 6px 40px 6px 40px;
    }

    border: 2px solid #dddddd;
    border-radius: 9px;
    position: relative;
    padding: 8px 40px 8px 40px;
    margin-top: 15px;
    margin-bottom: 8px;

    span {
        position: absolute;
        top: 50%;
        left: 9px;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    button {
        display: ${p => (p.isSearchText ? 'block' : 'none')};
        border: none;
        outline: none;
        background: none;
        margin: 0;
        padding: 0;
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        cursor: pointer;
    }
`
